/**
 * UI element: Accessible tooltips for font awesome icons
 * requires: jquery, bootstrap tooltip, font-awesome
 */
var springSpace = springSpace || {};
springSpace.sui = springSpace.sui || {};

/**
 * font-awesome icon accessible tooltip, works on fa icons
 * Requires an element with class icon-label that contains the text. That element should also be .sr-only so it is hidden to browsers but accessible to screen readers.
 * The .icon-label must be the next sibling of the .fa
 * @param {Object} [opts] options object...
 * @param {String} [opts.parent=body] Enable tooltips within this selector
 * @param {String} [opts.placement=top] bootstrap tooltip placement setting (top, bottom, left, right)
 */
springSpace.sui.icontip = function (opts) {
	//Options:
	if (typeof opts == 'undefined') { opts = {}; }
	//are we checking the whole page or just the children of a parent element
	if (!opts.parent) {
		var $parent = $('body');
	} else {
		var $parent = $(opts.parent);
	}
	opts.placement = (opts.placement) ? opts.placement : 'top';
	
	$parent.find('.fa + .icon-label').each(function(i,el){
		//el is the icon-label
		var $label = $(el);
		var title = $label.html();
		if (title !== '') {
			//Is there a parent button/a element, if so we'll put the tooltip on that.
			$parent = $label.parent('button, a');
			if ($parent.length == 0) {
				//it no a/button we'll just use the .fa itself
				var $parent = $label.prev('.fa');	
			}
			if ($parent.length == 1) {
				if ($parent.data && $parent.data('bs.tooltip')) {
					//it already has a tooltip, so stop here
					return;
				}
				//initialize the tooltip
				$parent.tooltip({
					title: title,
					html: true,
					placement: opts.placement
				});
			}
		}
	});	
	
}



/*
	HTML:
	
	<button type="button"><i class="fa fa-info"></i><span class="sr-only icon-label">Information</span></button>
	<a href="#"><i class="fa fa-info"></i><span class="sr-only icon-label">Information</span></a>
	
	The .icon-label must be the next sibling of the i.fa
	.icon-label doesn't have to be .sr-only but it makes things less redundant for visual users
	
	JS:
	springSpace.sui.icontip(); //activate all on page
	springSpace.sui.icontip({ parent: '#loaded' }); //activate all tooltips inside the element with id=loaded
	springSpace.sui.icontip({ parent: '#loaded', placement: 'right' }); //activate all tooltips inside the element with id=loaded and make them open to the right
	
	
*/
